import projection from '../generated/pw2502f1.json'; import { AcceptanceManifest } from '../types';
export const pw2502f1AcceptanceManifest = projection as AcceptanceManifest;
